module.exports = __webpack_public_path__ + "img/30_15.543cdee6.png";